export class PhConfigLoaderModel {
  [key: string]: any;
}
